<template>
  <div class="settings-show-inactive">
    <ToggleSwitch
      v-model="model"
      :inputId="inputId"
      :disabled="disabled"
    />
    <label :for="inputId" class="settings-show-inactive__label">Show inactive</label>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import ToggleSwitch from 'primevue/toggleswitch';

defineOptions({ name: 'SettingsShowInactiveToggle' });

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  inputId: {
    type: String,
    default: 'settings-show-inactive',
  },
});

const emit = defineEmits(['update:modelValue']);

const model = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});
</script>

<style scoped>
.settings-show-inactive {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.settings-show-inactive__label {
  font-size: 0.8125rem;
  color: var(--crc-text-muted, var(--text-color-secondary));
  cursor: pointer;
  user-select: none;
}
</style>
